export const DoppeActionTypeBlogPostViewerLang = {
    defaultTexts: {
        blogPostTitle: 'Blog Post title',
        description: 'Describe the blog post you want to promote',
        blogPostButtonText: 'Read Now',
    }
}